import { render } from "./IconCalories.vue?vue&type=template&id=3f1e184f"
import script from "./IconCalories.vue?vue&type=script&lang=js"
export * from "./IconCalories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__